// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Button Component Styles */
.custom-button {
  border: none;
  cursor: pointer;
  font-family: var(--font-family-medium);
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  text-decoration: none;
  outline: none;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.custom-button:focus {
  outline: 0.125rem solid var(--color-primary);
  outline-offset: 0.125rem;
}

.custom-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Button Variants */
.custom-button--primary {
  background-color: var(--color-button);
  color: var(--color-white);
}

.custom-button--primary:hover:not(:disabled) {
  background-color: rgba(67, 142, 51, 0.9);
  transform: translateY(-0.0625rem);
}

.custom-button--primary:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 0.125rem 0.5rem rgba(67, 142, 51, 0.3);
}

/* Button Sizes */
.custom-button--small {
  height: 2.5rem;
  border-radius: 0.5rem;
  padding: var(--space-sm);
  font-size: var(--font-size-sm);
}

.custom-button--medium {
  height: 3.375rem;
  border-radius: 0.625rem;
  padding: var(--space-md);
  font-size: var(--font-size-lg);
}

.custom-button--large {
  height: 4rem;
  border-radius: 0.75rem;
  padding: var(--space-lg);
  font-size: var(--font-size-xl);
}

/* Mobile responsive styles removed - heights are already defined above */

/* Additional variants can be added here */
.custom-button--secondary {
  background-color: transparent;
  color: var(--color-white);
  border: 0.125rem solid var(--color-white);
}

.custom-button--secondary:hover:not(:disabled) {
  background-color: var(--color-white);
  color: var(--color-button);
}
`, "",{"version":3,"sources":["webpack://./src/styles/CustomButton.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,oDAAoD;AACtD;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,yEAAyE;;AAEzE,0CAA0C;AAC1C;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B","sourcesContent":["/* Custom Button Component Styles */\n.custom-button {\n  border: none;\n  cursor: pointer;\n  font-family: var(--font-family-medium);\n  font-weight: 600;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  text-decoration: none;\n  outline: none;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n\n.custom-button:focus {\n  outline: 0.125rem solid var(--color-primary);\n  outline-offset: 0.125rem;\n}\n\n.custom-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Button Variants */\n.custom-button--primary {\n  background-color: var(--color-button);\n  color: var(--color-white);\n}\n\n.custom-button--primary:hover:not(:disabled) {\n  background-color: rgba(67, 142, 51, 0.9);\n  transform: translateY(-0.0625rem);\n}\n\n.custom-button--primary:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: 0 0.125rem 0.5rem rgba(67, 142, 51, 0.3);\n}\n\n/* Button Sizes */\n.custom-button--small {\n  height: 2.5rem;\n  border-radius: 0.5rem;\n  padding: var(--space-sm);\n  font-size: var(--font-size-sm);\n}\n\n.custom-button--medium {\n  height: 3.375rem;\n  border-radius: 0.625rem;\n  padding: var(--space-md);\n  font-size: var(--font-size-lg);\n}\n\n.custom-button--large {\n  height: 4rem;\n  border-radius: 0.75rem;\n  padding: var(--space-lg);\n  font-size: var(--font-size-xl);\n}\n\n/* Mobile responsive styles removed - heights are already defined above */\n\n/* Additional variants can be added here */\n.custom-button--secondary {\n  background-color: transparent;\n  color: var(--color-white);\n  border: 0.125rem solid var(--color-white);\n}\n\n.custom-button--secondary:hover:not(:disabled) {\n  background-color: var(--color-white);\n  color: var(--color-button);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
